import ArrowIcon from "shared/assets/icons/RightArrow.svg";
import { ReactNode } from "react";

interface Props {
  data: Array<any>;
  keyName: string;
  onClick: (data: any) => void;
  columns?: number;
  renderItem?: (data: any) => ReactNode;
  title?: string;
}

export const MultiColumnList = ({
  data,
  keyName,
  onClick,
  columns = 2,
  renderItem,
  title,
}: Props) => {
  return (
    <>
      {title && (
        <h2 tw="font-base text-lg leading-none tracking-[-0.17px] py-6 px-4">
          {title}
        </h2>
      )}
      <div tw="flex flex-wrap border-b border-solid border-gray">
        {data.map((row, index) =>
          renderItem ? (
            <div key={index} tw="w-full">
              {renderItem(row)}
            </div>
          ) : (
            <li
              key={index}
              tw="text-center border-t border-solid border-gray odd:(border-r border-gray)"
              css={{ width: `${100 / columns}%` }}
            >
              <button
                tw="w-full bg-white border-none py-4 px-6 flex justify-between cursor-pointer"
                onClick={() => onClick(row)}
              >
                <span tw="font-normal text-xs leading-none text-secondary">
                  {row[keyName]}
                </span>
                <ArrowIcon />
              </button>
            </li>
          )
        )}
      </div>
    </>
  );
};
